import React from 'react'
import PropTypes from 'prop-types'

const RenderController = (props) => {
  const { children, showModal } = props

  if (!showModal){
    return null
  }

  return children
}

RenderController.propTypes = {
  children: PropTypes.node.isRequired,
  showModal: PropTypes.bool,
}

export default RenderController
